import React, { Component } from 'react';
import '../../themes/global.scss';
import '../../themes/job_summary.scss';
import '../../themes/payment.scss';
import { connect } from 'react-redux';
import { PlaidLink } from 'react-plaid-link';
import { createLoadingSelector } from '../../api/selectors';
import {
  ADD_PAYMENT_ACTION,
  ADD_ACH_PAYMENT_ACTION,
  submitPlaidToken,
  getPlaidToken,
  SUBMIT_PLAID_TOKEN,
  GET_PLAID_TOKEN,
} from '../../actions';
import CustomSpinner from '../../commonComponents/CustomSpinner';
import { Colors } from '../../themes/colors';
import AddCard from './AddCard';
import Button from '../../commonComponents/Button';
import BackButton from '../../commonComponents/BackButton';

class AddPayment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showBank: true,
    };
  }

  componentDidMount() {
    const { getPlaidToken } = this.props;
    getPlaidToken();
  }

  headerView() {
    const { showBank } = this.state;
    return (
      <div
        style={{
          flexDirection: 'row',
          display: 'flex',
          marginBottom: 20,
          borderBottomColor: Colors.success_500,
          borderBottomWidth: 1,
        }}
      >
        <Button
          text="Card"
          size="small"
          color={showBank ? 'primary' : 'secondary'}
          style={{ height: 40 }}
          textStyle={{ fontSize: 16 }}
          onClick={() => this.setState({ showBank: true })}
        />

        <div style={{ width: 20 }} />

        <Button
          text="Bank Account"
          size="small"
          color={showBank ? 'secondary' : 'primary'}
          style={{ height: 40 }}
          textStyle={{ fontSize: 16 }}
          onClick={() => this.setState({ showBank: false })}
        />
      </div>
    );
  }

  render() {
    const { showBank } = this.state;
    const { isLoading, plaidToken, submitPlaidToken } = this.props;

    if (isLoading) {
      return (
        <div className="floating_container" style={{ margin: 40 }}>
          <CustomSpinner isLoading={isLoading} />
        </div>
      );
    }

    return (
      <div className="component_container">
        <div
          className="floating_container"
          style={{
            margin: 20,
            padding: 40,
            justifyContent: 'flex-start',
            flexDirection: 'column',
          }}
        >
          <BackButton url="/dashboard/payment" />

          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            {this.headerView()}

            {showBank ? (
              <AddCard />
            ) : (
              <div style={{ margin: 50 }}>
                <PlaidLink
                  style={{
                    backgroundColor: Colors.error_500,
                    borderRadius: 25,
                    textAlign: 'center',
                    width: 300,
                    height: 50,
                    paddingRight: 20,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                  token={plaidToken}
                  onSuccess={(publicToken, metadata) => {
                    const obj = {
                      metadata,
                      publicToken,
                    };

                    submitPlaidToken(obj);
                  }}
                >
                  <p
                    style={{
                      color: Colors.white,
                      fontFamily: 'Nunito, sans-serif',
                      fontWeight: 'bold',
                    }}
                  >
                    Connect a bank account
                  </p>
                </PlaidLink>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
const loadingSelector = createLoadingSelector([
  ADD_PAYMENT_ACTION,
  ADD_ACH_PAYMENT_ACTION,
  GET_PLAID_TOKEN,
  SUBMIT_PLAID_TOKEN,
]);

const mapStateToProps = (state) => ({
  isLoading: loadingSelector(state),
  plaidToken: state.payments.plaidToken,
});

export default connect(mapStateToProps, { getPlaidToken, submitPlaidToken })(AddPayment);
